import { Grid, Switch } from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, FieldValues, FormProvider, useForm } from 'react-hook-form';
import {
  getDataDownloadSettings,
  IDataDownloadSettingsDTO,
  saveDataDownloadSettings,
} from 'wisestep-api';
import { WsTypography, WsTypoVariants, WsButton } from 'wisestep-base';

import { useWorkspaceContext } from '../../../../context';
import { AtsCustomAPIAccess, useAtsCustomAPIAccess } from '../../../../hooks/useAtsCustomAPIAccess';
import { warning, success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import FormSwitchLayout from '../../../careerPageSettings/components/formSwitchLayout';
import { HeaderBox } from '../../../jobSettings/components/HeaderBox';

import { defValues, fieldsAvailable, fieldsAvailableType, fieldsObject } from './helper';

const DownloadSettings = () => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [fields, setFields] = useState(fieldsObject);
  const [dataDownloadSettingsData, setDataDownloadSettingsData] =
    useState<IDataDownloadSettingsDTO>(defValues);
  const formDefaultValues = fields;
  const formOptions = {
    defaultValues: formDefaultValues,
  };
  const methodsMain = useForm(formOptions);
  const { handleSubmit, setValue, control, reset } = methodsMain;

  const workspaceContext = useWorkspaceContext();
  const { access: atsCustomAccessControl } = useAtsCustomAPIAccess([
    AtsCustomAPIAccess.MANAGE_DATA_DOWNLOAD_SETTINGS_IN_CANDIDATES,
  ]);

  const manageAccess = workspaceContext.owns || atsCustomAccessControl[0];

  useEffect(() => {
    const fetchDataDownloadSettings = async () => {
      const getDataDownloadSettingsRes = await getDataDownloadSettings();

      if (getDataDownloadSettingsRes?.data.allowedColumns) {
        setDataDownloadSettingsData(getDataDownloadSettingsRes.data);
      } else {
        const tempData = getDataDownloadSettingsRes.data;
        tempData.allowedColumns = [];
        setDataDownloadSettingsData({ ...tempData });
      }
    };
    fetchDataDownloadSettings();
  }, []);
  useEffect(() => {
    const json = fieldsAvailable.reduce((json, value) => {
      json[value] = dataDownloadSettingsData?.allowedColumns.indexOf(value) != -1;
      return json;
    }, fieldsObject);
    if (json) setFields(json);
    reset(json);
  }, [dataDownloadSettingsData?.allowedColumns, reset]);

  const updateAllowedFields = async (data: FieldValues) => {
    const allowedColumns: string[] = [];
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        allowedColumns.push(key);
      }
    });
    try {
      if (dataDownloadSettingsData) {
        const tempData: IDataDownloadSettingsDTO = dataDownloadSettingsData;
        if (dataDownloadSettingsData.workspaceId === 'DEFAULT') {
          delete dataDownloadSettingsData.id;
          delete dataDownloadSettingsData.workspaceId;
        }
        tempData.allowedColumns = allowedColumns;
        await saveDataDownloadSettings(tempData);
        setNotification(success('Attributes settings applied successfully'));
      }
    } catch (error) {
      setNotification(warning('Something Went Wrong , Please try again'));
    }
  };
  const getText = (e) => {
    if (e == 'Current Job Title') {
      return 'Latest Job Title';
    } else {
      return e;
    }
  };

  return (
    <FormProvider {...methodsMain}>
      <HeaderBox mb={4}>
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>
          Select attributes to Download in Talentpool, Submissions and CRM
        </WsTypography>
        {manageAccess && (
          <WsButton type="submit" onClick={handleSubmit(updateAllowedFields)} size="small">
            Save
          </WsButton>
        )}
      </HeaderBox>
      <Grid container direction="column" maxHeight="100vw" spacing={2}>
        {fields &&
          fieldsAvailable.map((e: fieldsAvailableType) => (
            <FormSwitchLayout
              key={e}
              label={getText(e)}
              gridValue={6}
              border="solid"
              justifyContent="space-between"
            >
              <Controller
                name={e}
                control={control}
                render={(props) => (
                  <Switch
                    checked={props.field.value}
                    onChange={() => setValue(e, !props.field.value)}
                  />
                )}
              />
            </FormSwitchLayout>
          ))}
      </Grid>
    </FormProvider>
  );
};

export default DownloadSettings;
